import React, { useState, useEffect } from "react";
import { Container } from "@mui/material";
import ParticlesBg from "particles-bg";
import "../utils/collagestyles.css";
import NavMenu from "./Menu";
import { forSaleAtom } from "./atoms";
import axios from "axios";
import { useRecoilState } from "recoil";
import "react-lazy-load-image-component/src/effects/blur.css";
import '../utils/collagestyles.css'
import CardItem from '../utils/card'

const ViewItemsForSale = () => {
   
    const [items, setItemsForSale] = useRecoilState(forSaleAtom);

    const fetchData = async () => {
      try {
        
        const response = await axios.get('/itemsforsale')
        setItemsForSale(response.data);
      } catch (err) {
        // Handle Error Here
        console.error(err);
      }
    }
    useEffect(() => {
      fetchData()
    }, [])
  
    return (
      <>
     <NavMenu />
     <ParticlesBg num={10} type="circle" bg={true} />

        <Container maxWidth="sm"	>
            <h1>For Sale!</h1>
            <hr className="mt-4 mb-4" />
            <h4>The following puppies are currently available unless marked as sold.</h4>
          <section>
         
              {items.map((image, index) => (
                <React.Fragment>
                   <CardItem item={image} key={image.name} />
                   <br></br>
                   </React.Fragment>
              ))}
         
          </section>
          </Container>
       </>
  
    )
  }
  export default ViewItemsForSale;